import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: 'flights',
    tagSub: "flights",
    exact: false,
    path: PATHS.FLIGHTS.path,
    show: true,
    icon: "faPlane",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.FLIGHT_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "baggages",
            group: "baggages",
            tagSub: "flights",
            path: PATHS.BAGGAGE.LIST.path,
            exact: false,
            icon: 'faSuitcaseRolling',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.BAGGAGE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createFareRule",
                    group: "baggages",
                    tagSub: "flights",
                    path: PATHS.BAGGAGE.CREATE.path,
                    exact: false,
                    icon: '',
                    show: false,
                }, {
                    title: "updateFareRule",
                    group: "baggages",
                    tagSub: "flights",
                    path: PATHS.BAGGAGE.DETAIL.path,
                    exact: false,
                    icon: '',
                    show: false,
                }
            ]
        },
        {
            title: "priceConfigFlight",
            group: "priceConfigFlight",
            tagSub: "flights",
            path: PATHS.FLIGHTS.PRICE_CONFIG.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FLIGHT_PRICE_CONFIG,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
        },
        {
            title: "airports",
            group: "airports",
            tagSub: "flights",
            path: PATHS.AIRPORT.LIST.path,
            exact: false,
            icon: 'faPlaneArrival',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.AIRPORT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createAirport",
                    group: "airports",
                    tagSub: "flights",
                    path: PATHS.AIRPORT.CREATE.path,
                    exact: false,
                    icon: '',
                    show: false,
                }, {
                    title: "updateAirport",
                    group: "airports",
                    tagSub: "flights",
                    path: PATHS.AIRPORT.DETAIL.path,
                    exact: false,
                    icon: '',
                    show: false,
                }
            ]
        },
        {
            title: "fareRules",
            group: "fareRules",
            tagSub: "flights",
            path: PATHS.FARE_RULES.LIST.path,
            exact: false,
            icon: 'faClipboardList',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FARE_RULES,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createFareRule",
                    group: "fareRules",
                    tagSub: "flights",
                    path: PATHS.FARE_RULES.CREATE.path,
                    exact: false,
                    icon: '',
                    show: false,
                }, {
                    title: "updateFareRule",
                    group: "fareRules",
                    tagSub: "flights",
                    path: PATHS.FARE_RULES.DETAIL.path,
                    exact: false,
                    icon: '',
                    show: false,
                }
            ]
        },
        {
            title: "flight",
            group: "flight",
            tagSub: "flights",
            exact: false,
            icon: 'faClipboardList',
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FLIGHT,
            permissions: [DEFINE.GENERAL.PERMISSION.UPDATE],
            children: []
        },
        {
            title: "configSourceFlight",
            group: "config-source-flight",
            tagSub: "flights",
            path: PATHS.CONFIG_SOURCE_FLIGHT.path,
            exact: false,
            icon: 'faShekelSign',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CONFIG_SOURCE_FLIGHT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
        }
    ],
}]